
import { NgFor, NgIf, CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Injector, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation, forwardRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Params, Router, RouterLink, RouterOutlet } from '@angular/router';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { FileManagerComponent } from 'app/modules/admin/apps/file-manager/file-manager.component';
import { FileManagerService } from 'app/modules/admin/apps/file-manager/file-manager.service';
import { Item, Items, ItemPagination, ItemLabel, IAlert, pickerDirectory, AssetListReponse, AssetsSearch, SortingPreference } from 'app/modules/admin/apps/file-manager/file-manager.types';
import { BehaviorSubject, Observable, Subject, Subscription, takeUntil, throwError } from 'rxjs';
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule, MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { HttpClientModule } from "@angular/common/http";
import { MatTableModule } from '@angular/material/table';
import { iconTypes } from 'app/modules/admin/apps/file-manager/file-manager.constants';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { FuseFindByKeyPipe } from '@fuse/pipes/find-by-key/find-by-key.pipe';
import { DocumentService } from 'app/services/document.service';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { MatExpansionModule, MatExpansionPanel, MatExpansionPanelHeader } from '@angular/material/expansion';
import { cloneDeep, isArray } from 'lodash';
import { EventService } from 'app/services/event.service';
import { Asset, AssetPathItem, CreateFolder } from 'app/models/document';
import * as consts from 'app/shared/global-constants';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { Util } from 'app/models/util';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { debounceTime } from 'rxjs/operators';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { FuseScrollbarDirective } from '@fuse/directives/scrollbar';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { fuseAnimations } from '@fuse/animations';
import { labelColorDefs } from 'app/shared/global-constants';
import { DndDragImageRefDirective, DndDraggableDirective, DndDropzoneDirective, DndHandleDirective} from 'ngx-drag-drop';
import { AlertMessageService } from 'app/services/alert.message.service';
import { ToastrModule, ToastrService, provideToastr } from 'ngx-toastr';
import { SharedPopoupComponent } from 'app/shared-component/shared-popoup/shared-popoup.component';
import { MatDialog } from '@angular/material/dialog';
import { LabelService } from 'app/services/label.service';
import { DataVisualBarComponent } from '../data-visuals/dv-bar/dv-bar.component';
import { MatDividerModule } from '@angular/material/divider';
import { FileItem } from 'ng2-file-upload';
import { OverlayModule } from '@angular/cdk/overlay';
import { FavouriteService } from 'app/services/favourite.service';
import { FileSizePipe } from '@fuse/pipes/file-size.pipe';
import { LpmLabelPipe } from '@fuse/pipes/lpm-label.pipe';
import { FullNamePipe, getFullName } from '@fuse/pipes/full-name.pipe';
import { AuthService } from 'app/services/auth.service';
import { ActionRegistryService } from 'app/shared/action-registry.service';
import { DesktopAgentService } from 'app/services/desktop-agent.service';
import { NgxLoadingModule } from 'ngx-loading';
import { ActionDirective } from '@fuse/directives/action.directive';
import { CUSTOM_THEME_ELEMENTS_CLASSES } from 'app/constants';
import {PermissionsService} from '../permissions/permissions.service'
import { DesktopAgentBannerComponent } from '../desktop-agent/desktop-agent-banner.component';

@Component({
    selector: 'app-search-result',
    templateUrl: './search-result.component.html',
    styleUrl: './search-result.component.scss',
    animations: [
        fuseAnimations,
        trigger('fadeIn', [
            state('void', style({ opacity: 0 })),
            state('*', style({ opacity: 1 })),
            transition(':enter', animate('600ms ease-in')),
        ]),
        trigger('overlayAnimation', [
            transition(':enter', [
                style({ opacity: 0, transform: 'scale(0.5)' }),
                animate('200ms ease-out', style({ opacity: 1, transform: 'scale(1)' })),
            ]),
            transition(':leave', [
                animate('200ms ease-in', style({ opacity: 0, transform: 'scale(0.5)' })),
            ]),
        ]),
        trigger('slideDown', [
            state('void', style({
                height: '0',
                opacity: '0',
                overflow: 'hidden',
            })),
            state('*', style({
                height: '*',
                opacity: '1',
            })),
            transition(':leave', [
                animate('0.3s ease-out')
            ]),
        ])
    ],
    encapsulation: ViewEncapsulation.None,
    // changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        MatSidenavModule,
        RouterOutlet,
        NgIf,
        RouterLink,
        NgFor,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        MatCheckboxModule,
        MatOptionModule,
        MatRippleModule,
        MatFormFieldModule,
        MatInputModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatSortModule,
        HttpClientModule,
        MatTableModule,
        FuseFindByKeyPipe,
        MatMenuModule,
        CommonModule,
        MatExpansionModule,
        FuseFindByKeyPipe,
        MatMenuModule,
        CommonModule,
        MatExpansionModule,
        MatPaginatorModule,
        ScrollingModule,
        FuseScrollbarDirective,
        DndDraggableDirective,
        DndHandleDirective,
        DndDragImageRefDirective,
        DndDropzoneDirective,
        ToastrModule,
        DataVisualBarComponent,
        MatDividerModule,
        OverlayModule,
        FileSizePipe,
        forwardRef(() => LpmLabelPipe),
        NgxLoadingModule,
        ActionDirective,
        FullNamePipe,
        DesktopAgentBannerComponent
    ],
})
export class SearchResultComponent implements OnInit, OnDestroy {
    @Input() inputSearch:AssetsSearch = null;
    @Output() folderNavigate = new EventEmitter();
    @ViewChild('matDrawer', { static: true }) matDrawer: MatDrawer;
    @ViewChild('viewport', { static: false }) viewport: CdkVirtualScrollViewport;

    drawerMode: 'side' | 'over';
    selectedItem: Asset;
    parentItem: Asset;
    assets: Asset[] = [];
    folders = null;
    files = null;

    private _unsubscribeAll: Subject<any> = new Subject<any>();
    labelColors: any;
    labels = [];
    viewMode: any;

    @ViewChild(MatPaginator) private _paginator: MatPaginator;
    @ViewChild(MatSort) private _sort: MatSort;
    page: ItemPagination = new ItemPagination();
    isLoading: boolean = true;
    iconTypes: any = iconTypes;

    radius: number;
    color: string;
    isStatsPanelOpen = false;
    // we create an object that contains coordinates 
    menuTopLeftPosition = { x: 0, y: 0 };

    // reference to the MatMenuTrigger in the DOM 
    @ViewChild('fmItemActionMenuItemTrigger', { static: true }) matMenuTrigger!: MatMenuTrigger;
    @ViewChild('filterPanel', { static: true }) filterPanel: MatExpansionPanel;
    @ViewChild('multiItemSelectPanel', { static: true }) multiItemSelectPanel: MatExpansionPanel;
    
    selectedRows: Asset[] = [];
    lastSelectedIndex: number = -1;
    routeFolderId = null;

    public paths = [];
    pageLimitList = consts.pagelimits;
    total = 0;
    showScrollToTopButton = false;
    private scrollSubscription: Subscription;

    panelOpenState = false;
    cancelForm: UntypedFormGroup;

    draggable = {
        // note that data is handled with JSON.stringify/JSON.parse
        data: "asset",
        effectAllowed: "move",
        disable: false,
        handle: true
      };

    //file uploading
    disableAll: boolean = false;
    isError: boolean = false;
    error: string = null;
    uploadInitiated: boolean = false;
    isFileOver: boolean = false;
    fileOverSubject: Subject<boolean> = new Subject<boolean>();
    fileOverSubscription: Subscription;
    totalAssets:{files:number;folders:number}={files:0,folders:0}
    method:string=""
    assetsSearch:AssetsSearch=new AssetsSearch()
    assetPaths: { [key: string]: AssetPathItem[] } = {};
    hoveredAssetId:string=""
    isBreadCrumbOpen:boolean=false
    teamDecorator = {};
    isAllRowsSelected:boolean = false;
    isWebComponent:boolean = false;
    WebInputParams = this.util.getWebComponentInputParams(); 

    // -----------------------------------------------------------------------------------------------------

    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        public _fileManagerComponent: FileManagerComponent,
        private _fileManagerService: FileManagerService,
        public docService: DocumentService,
        public eventSer: EventService,
        public util: Util,
        private el: ElementRef,
        private _formBuilder: UntypedFormBuilder,
        private _fuseConfirmationService: FuseConfirmationService,
         private _fuseMediaWatcherService: FuseMediaWatcherService,
         private _alertService: AlertMessageService,
         private _matDialog: MatDialog,
         private labelService :LabelService,
         private toastr :ToastrService,
         private favService :FavouriteService,
         private authService: AuthService,
         private _actionRegistry: ActionRegistryService,
         private _desktopAgentService: DesktopAgentService,
         private _permissionsService: PermissionsService,
         private _injector: Injector

    ) {
        this.page.orderOn = 'type';
        this.isWebComponent = this.util.getIsWebApp();
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {

        if (this.isWebComponent && this.inputSearch) {
            this.assetsSearch = this.inputSearch;
            this.setAssetSearch();
            this.getAssets();
        } else {
            this._activatedRoute.queryParams.subscribe(params => {
                this.assetsSearch = new AssetsSearch();
                Object.entries(params).forEach(([key, value]) => {
                    this.assetsSearch[key] = value === 'true' ? true : value === 'false' ? false : value;
                });
                this.setAssetSearch();
                this.getAssets();
            });
        }
        
        //Load custom icons into material icon registry; ex. <mat-icon [svgIcon]="'png'"></mat-icon>
        this._fileManagerService.registerIcons();

        // TODO - set viewMode default based on user preference
        this.viewMode = this._fileManagerService.viewMode;

        // Subscribe to media query change
        this._fuseMediaWatcherService.onMediaQueryChange$('(min-width: 1200px)')
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe((state) => {
            // Calculate the drawer mode
            this.drawerMode = state.matches ? 'side' : 'over';

            // Mark for check
            this._changeDetectorRef.markForCheck();
        });
        // // Get the label colors
        this.labelColors = labelColorDefs;
        this.getLabels();

        // Refresh search results after a trash/restore/etc. elsewhere signals a data change
        this.eventSer.getData
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                this.getAssets();
            });
    }

    getAssets(){
        this.resetSelectedRows();
        this.docService.getAssets(this.page,this.assetsSearch).then((res) => {
            const response=this.docService.getData(res)
            const meta=this.docService.getMeta(res)
            this.assets=response
            this.total=meta.total
            this.totalAssets.files=meta.totalFiles
            this.totalAssets.folders=meta.totalFolders
            if (this.assets && this.assets.length > 0) {
                this.folders = this.assets.filter((item) => item.type === 'FOLDER');
                this.files = this.assets.filter((item) => item.type === 'FILE');
            }
            this.isLoading=false
            console.log(res)
              this.renderTeamMembers();
        }).catch(error=>{
            console.log(error)
            this.isLoading=false
        })
    }

      renderTeamMembers() {
        this.assets.forEach((asset: Asset) => {
            asset["innerDiv"] = "";

            if (asset.createdBy.profilePic) {
                asset["innerDiv"] += `<img
                class="shrink-0 w-10 h-10 mr-4 rounded-full overflow-hidden object-cover object-center"
                src="${asset.createdBy.profilePic}"
                [alt]="'Activity image'">`;
            } else {
                const name = getFullName(asset.createdBy).toUpperCase();
                const dec_class = this.util.getUserColor(name);
                const [first, last] = name.split(" ");

                const initials = `${first?.substring(0, 1) || ''}${last?.substring(0, 1) || ''}`;
                this.teamDecorator[name] = initials;
                
                asset["innerDiv"]       += ` <div class=" ${dec_class} flex shrink-0 items-center justify-center w-10 h-10 mr-4 rounded-full font-10">
                    ${this.teamDecorator[name]}
                </div>`;
            }
        });
	}
  
    getLabels() {
        this.labelService.getLabels().then((res) => {
            this.labels = this.labelService.getData(res);
        }).catch((error) => {
            console.log(error);
        })
    }
    
    getAssetLabels(assignedLabelIds:string){
        return this.labels.filter(label=>{
            return assignedLabelIds?.includes(label.id)
        })
    }

    ngAfterViewInit(): void {
        if(this.assets.length>0)
        setTimeout(() => this.subscribeToScrollEvent(), 4000);
    }

    setPath(items) {
        const pathItems = cloneDeep(items);
        this.paths = [];

        // Prepare the current folder
        let currentFolder = null;

        // Get the current folder and add it as the first entry
        if (this.routeFolderId) {
            currentFolder = pathItems.find(item => item.id === this.routeFolderId);
            this.paths.push(currentFolder);
        }

        // Start traversing and storing the folders as a path array
        // until we hit null on the folder id
        while (currentFolder.id) {
            currentFolder = pathItems.find(item => item.id === currentFolder.folderId);
            if (currentFolder) {
                this.paths.unshift(currentFolder);
            }
        }

        this.paths = this.util.scopePathToRoot(this.paths);
    }

    /**
     * Handles the page change event.
     * @param e The page event containing the new page information.
     */
    onPageChanged(e: PageEvent) {
        this.page.length = e.length;
        this.page.size = e.pageSize;
        this.page.page = e.pageIndex;
        this.util.setPageLimit(this.page.size);
        this.getAssets()
    }

    /**
     * Sorts the data based on the provided sort object.
     * 
     * @param sort - The sort object containing the active sorting property.
     */
    sortData(sort : Sort){
        this.page.orderOn = sort.active;
        this.assetsSearch.sortDirection=this.util.getSortDirection(sort.direction)
        const sortPrefernce:SortingPreference={viewName:'Home',sort}
        this.util.setSortingPreference(sortPrefernce)
        this.assetsSearch.sortColumn=sort.active as any
        this.getAssets();
     } 

    /**
     * Lifecycle hook that is called when the component is destroyed.
     * It is used to perform cleanup tasks such as unsubscribing from subscriptions.
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
        if (this.scrollSubscription) {
            this.scrollSubscription.unsubscribe();
        }
    }

    /**
     * Subscribes to the scroll event of the viewport element.
     * @returns {void}
     */
    subscribeToScrollEvent() {
        this.scrollSubscription = this.viewport.elementScrolled().subscribe(event => {
            this.handleScrollEvent(event);
        });
    }
    
    handleScrollEvent(event) {
        this.showScrollToTopButton = this.viewport.getOffsetToRenderedContentStart() > 30;
    }

    scrollToTop() {
        // Use the viewport's API to scroll to the top
        //this.viewport.scrollToOffset(0);
        //this.viewport.scrollToIndex(0);
        this.viewport.scrollTo({ top: 0, behavior: 'smooth' });
        this.showScrollToTopButton = false;
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * On backdrop clicked
     */
    onBackdropClicked(): void {
        // Go back to the list
        this._router.navigate(['./'], { relativeTo: this._activatedRoute });

        // Mark for check
        this._changeDetectorRef.markForCheck();
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    /**
     * init file uploader; configures the drag and drop area
     */
    configDragDropArea() {
        // this.fileUploader =this.util.fileUpload(this.routeFolderId)
    }

    /**
     * Opens the details view for the current (parent) folder.
     */
    viewDetails(): void {
        const routerPath = this._activatedRoute.snapshot.url.join('/');
        //console.log(routerPath);
        const currentFolderId = routerPath.split('/').pop();
        const parentFolderId = this._fileManagerService.getItemById(currentFolderId);
        if (parentFolderId) {
            console.log(parentFolderId);
        }

        if (currentFolderId) {
            //console.log(currentFolderId);
            this._router.navigate(['apps/file-manager/folders/' + currentFolderId + '/details/' + currentFolderId]);
        } else {
            console.log('is root');
        }
    }

    /**
     * 
     */
    viewStats(): void {
        console.log('viewStats');
    }

    /**
     * Translate the asset size to human readable format KB and MB
     */
    getAssetSize(asset: Asset): string {
        let size = 0;
        size = asset.size ? asset.size : 0;
        size = size / 1000;
        if (size < 1000) {
            return size.toFixed(1) + ' KB';
        } else {
            const sizeInMb = size / 1024;
            return sizeInMb.toFixed(1) + ' MB';
        }
    }
    
    /**
     * Toggle the viewMode between 'grid' and 'cards'
     *
     * @param viewMode
     */
    toggleViewMode(): void {
        this._fileManagerService.viewMode = this._fileManagerService.viewMode === 'grid' ? 'cards' : 'grid';
        this.viewMode = this._fileManagerService.viewMode;
    }

    /** 
     * Method called when the user click with the right button 
     * @param event MouseEvent, it contains the coordinates 
     * @param item Our data contained in the row of the table 
     */
    onRightClick(event: MouseEvent, selectedItem: Asset): void {

        // preventDefault avoids to show the visualization of the right-click menu of the browser 
        event.preventDefault();

        // we record the mouse position in our object 
        this.menuTopLeftPosition.x = event.clientX;
        this.menuTopLeftPosition.y = event.clientY;

        // we open the menu 
        // we pass to the menu the information about our object 
        this.matMenuTrigger.menuData = { item: selectedItem };

        // we open the menu 
        this.matMenuTrigger.openMenu();
    }

    /**
     * Toggle star
     */
    toggleStar(asset: Asset): void {
        //this.isLoading = true;
        asset.favourite = asset.favourite ? !asset.favourite : true;
        this.favService.favorite(asset.id, asset.favourite).then((res) => {
            if (!asset.favourite) {
                this.toastr.warning("Removed from favorite")
            } else {
                this.toastr.info("Added to favorite")
            }
            this.eventSer.checkUnreadMessages.emit("favourite");
            this.getAssets()
        }).catch((error) => {
            console.log(error);
        })
    }

    /**
     * Toggle star
     */
    toggleStar_multi(): void {
        // Update the asset
        if (this.selectedRows.length > 0) {
            this.selectedRows.forEach(asset => {
                asset.favourite = !asset.favourite;
            });
        }
    }

    /**
     * Toggles the filter panel open and close.
     * Clears the filters on close.
     * Closes the multiItemSelectPanel if opening the filterPanel.
     * Clears the selectedRows if filter panel is open and then user makes a parameter selection.
     */
    toggleFilterPanel(): void {
        // toggle the filterPanel open and close
        this.filterPanel.toggle();
        // TODO - clear the filters on close

        //if opening the filterPanel, close the multiItemSelectPanel
        if (this.filterPanel.opened) {
            this.selectedRows = [];
            this.multiItemSelectPanel.close();
        }

        //TODO - if filter panel is open and then user makes a parameter selection, 
        //close multiItemSelectPanel and clear selectedRows.
    }

    /**
     * 
     * @param item 
     * Select rows by clicking on the available row space
     */
    onSelect(file: Asset, index: number, event: MouseEvent) {
        console.log(`Clicked index: ${index}, Last selected index: ${this.lastSelectedIndex}, Shift key: ${event.shiftKey}`);

        if (event.shiftKey && this.lastSelectedIndex !== -1) {
            const start = Math.min(index, this.lastSelectedIndex);
            const end = Math.max(index, this.lastSelectedIndex);
            const newSelections = new Set(this.selectedRows.map(item => item.id));
    
            for (let i = start; i <= end; i++) {
                if (i !== this.lastSelectedIndex) {
                    const assetId = this.assets[i].id;
                    if (newSelections.has(assetId)) {
                        newSelections.delete(assetId); // Deselect if already selected
                    } else {
                        newSelections.add(assetId); // Select if not already selected
                    }
                }
            }
    
            // Convert the Set back to the array of selected rows based on IDs
            this.selectedRows = this.assets.filter(asset => newSelections.has(asset.id));
        } else {
            const isSelected = this.selectedRows.some(selectedFile => selectedFile.id === file.id);
            if (isSelected) {
                // Deselect the row if it's already selected
                this.selectedRows = this.selectedRows.filter(selectedFile => selectedFile.id !== file.id);
            } else {
                // For single selection, replace the current selection
                this.selectedRows = [file];
                this.lastSelectedIndex = index; // Update last selected index for future shift selections
            }
        }
    
        // Panel visibility logic remains the same
        if (this.selectedRows.length > 0) {
            this.multiItemSelectPanel.open();
        } else {
            this.multiItemSelectPanel.close();
        }

          // Log the current selection for debugging
        console.log(`Selected rows:`, this.selectedRows.map(item => item.id));
    }
    
    /**
     * Checks if a file is selected.
     * @param file - The file to check.
     * @returns True if the file is selected, false otherwise.
     */
    isSelected(file: any): boolean {
        return this.selectedRows.some(selectedFile => selectedFile.id === file.id);
    }

    /**
     * Cancels the bulk action by clearing the selected rows and closing the multi-item select panel.
     */
    cancelBulkAction(): void {
        this.selectedRows = [];
        this.multiItemSelectPanel.close();
        this.isAllRowsSelected = false;
    }

    /**
     * Downloads the specified asset.
     * 
     * @param asset - The asset to download.
     */
    download(asset : Asset): void {
        this._fileManagerService.openDialog_download(asset);
    }

    /**
     * Downloads multiple files as a zip.
     * Files will be identified in the backend by the selectedRows array.
     * For each file, checks if the user has permission to download.
     * If the user does not have permission, rejects all and returns an error message.
     * If the user has permission, downloads the files as a zip.
     */
    download_multi(): void {
        //TODO - download multiple files as a zip. Files will be identified in the backend by the selectedRows array. 
        //For each file, check if user has permission to download. If no permission, reject all and return error message.
        //If user has permission, download as zip.
        let assetIds: string[] = []
        if (this.selectedRows.length>1) {
            assetIds = this.selectedRows.map((x) => x.id);
            this._fileManagerService.openDialog_download_multi(assetIds)
        }
        else {
            const asset = this.selectedRows[0]
            this._fileManagerService.openDialog_download(asset);
        }
    }

    /**
     * Moves the specified file to the trash.
     * 
     * @param file - The file to be moved to the trash.
     * @param type - The type of file being moved to the trash.
     */
    trash(file: Asset): void {
        const ids: string[] = [file.id];
        this._fileManagerService.openDialog_trash(ids, file.type.toLowerCase());
    }

    /**
     * Trashes the selected assets.
     * If only one asset is selected, it trashes that asset.
     * If multiple assets are selected, it presents a confirmation prompt and then trashes all selected assets.
     */
    trash_multi(): void {
        const assetIds: string[] = this.selectedRows.map((x) => x.id);
        const isAnyNotDeletable = this.selectedRows.some(file => !file.deletable);
        if(isAnyNotDeletable){
            this.toastr.error("One or more selected items cannot be deleted.")
            return;
        }
        if (this.selectedRows.length > 1) this._fileManagerService.openDialog_trash_multi(assetIds);
        else this.trash(this.selectedRows[0]);
    }

    /**
     * Stops the propagation of the specified mouse event.
     * 
     * @param event - The mouse event to stop propagation for.
     */
    stopPropagation(event: MouseEvent): void {
        this._fileManagerComponent.stopPropagation(event);
    }

    /**
     * Toggles the expansion panel.
     * @param panel - The MatExpansionPanel to toggle.
     * @param event - The MouseEvent that triggered the toggle.
     */
    togglePanel(panel: MatExpansionPanel, event: MouseEvent): void {
        event.stopPropagation(); // Prevents additional event handling
        panel.toggle(); // Toggles the expansion panel
    }

    /**
     * Returns the tooltip for the status of a file item.
     * 
     * @param item - The file item.
     * @returns The tooltip for the status of the file item.
     */
    getStatusTooltip(item : FileItem): string {
       return this.util.getStatusTooltip(item);
    }

    /**
     * Returns the icon color for the given file item.
     * 
     * @param item - The file item.
     * @returns The icon color.
     */
    getIconColor(item : FileItem): string {
      return this.util.getIconColor(item);
    }

    /**
     * Returns the progress of a file item.
     * 
     * @param item - The file item.
     * @returns The progress value.
     */
    getProgress(item : FileItem): number {
      return this.util.getProgress(item);
    }
    
    /**
     * Returns the color associated with the given file type.
     * 
     * @param filetype - The file type.
     * @returns The color associated with the file type.
     */
    getTypeColor(filetype: string): string {
        return this.util.getTypeColor(filetype);
    } 

    shared(item): void {
        const dialogRef = this._matDialog.open(SharedPopoupComponent,
           {
            maxWidth: '700px',
            injector: this._injector,
            data : item,
          });
    }

    setAssetSearch(){
        this.assetsSearch.start = this.assetsSearch.start? new Date(this.assetsSearch.start): null
        this.assetsSearch.end = this.assetsSearch.end? new Date(this.assetsSearch.end): null

        const labelsSearch = this.assetsSearch.labels
        if(labelsSearch){
            this.assetsSearch.labels = Array.isArray(labelsSearch)?labelsSearch:[labelsSearch] 
        }
    }   

      toggleLabel(assetId, labelId, event : MatCheckbox): void {
        if(!event.checked){
            this.labelService.assignLabel(labelId, assetId).then((res) => {
                this.toastr.info("Label applied");
                this.getAssets();
            }).catch((error) => {
                console.log(error);
            })
        } else 
            this.deleteLabel(labelId, assetId);
    }

     deleteLabel(labelId,assetId){
        this.labelService.removeLabel(labelId, assetId).then((res)=>{
            this.toastr.warning("Label removed");
            this.getAssets();
        }).catch((error)=>{
          console.log(error);
        })
      }

    selectedLabel(id:string,list:any[]) {
        if(list) {
            const index=list.findIndex(item=>item.id===id)
            return index==-1 ? false : true;
        }
    }

    navigateToFolder(folderId: string) {
        if(this.isWebComponent){
            this.folderNavigate.emit(folderId);
            return;
        }
        this._router.navigate(['/apps/file-manager/folders/' + folderId]);
    }

    loadTooltipText(assetId: string) {
        this.isBreadCrumbOpen = true
        this.hoveredAssetId = assetId
        if (!this.assetPaths[assetId]) {
            this.docService.getAssetFullPath(assetId).subscribe(path => {
                this.assetPaths[assetId] = this.util.scopePathToRoot(path as any);
            });
        }
    }
    
    getParentLink(id:string){
        const rootLink = this.util.getRootFromSession()
        return rootLink == id ? ['/apps/file-manager/'] : ['/apps/file-manager/folders/', id];
    }  
     
    hideBreadCrumb(){
        this.isBreadCrumbOpen=false
    }

    /**
    * Move Asset
    */
    move(item: Asset): void {
         if(!this._permissionsService.canMove(item)){
            this.toastr.error("You do not have permission to move this item.");
            return;
        }

        this._fileManagerComponent.moveItemDialog(item);
    }

    move_multi(): void {
        console.log("move_multi");
        //TODO - for each selected item, move to the destination folder
    }

    animationStarted(event: any) {
        console.log('Animation started', event);
    }

    /**
     * Edits a file.
     * @param asset - The asset to be edited.
     */
    editFile(asset: Asset) {
        this.editFileInNewApp(asset, false) //edit existing file
    }

     /**
     * Opens the file in a new tab for preview after getting temporary token for authentication
     * @param asset - The asset object to be opened.
     */
     previewFile(asset:Asset){
        this.util.viewFile(asset)
    }

    /**
     * Opens the file in a new tab for editing after getting temporary token for authentication
     * @param asset - The asset to edit.
     * @param isNew - Indicates whether the asset is new or not. Default is false.
     */
    editFileInNewApp(asset: Asset, isNew: boolean = false) {

        // first get temporary token for authentication

        const assetId = isNew ? this.routeFolderId : asset.id;
        const assetName = isNew ? "new_doc" : encodeURIComponent(asset.name);

        this.authService.getToken().then((res) => {
            const token = this.docService.getData(res).token
            this.isLoading=false
            const dms_editor_url=this.util.getDmsEditorUrl()
            const user_type=this.util.getIsWebApp() ?'L':'D'
            const url = dms_editor_url + "/#/auth/" + assetId + "/" + "?name=" + assetName + "&new=" + isNew + "&t=" + token+"&dut="+user_type ;
            this.util.openExternalViewEditLink(url);
        })
            .catch((err) => {
                console.log(err);
            });
    }

    toggleCheckAll():void {

        this.isAllRowsSelected = !this.isAllRowsSelected;

        if (this.isAllRowsSelected) {
            this.selectedRows = this.assets;
        }
        if (!this.isAllRowsSelected) {
            this.selectedRows = [];
        }

        this.toggleMultiRowSelectedOptions()
    }

    toggleRowCheck(checked: boolean, asset: Asset = null):void {

        if (checked) {
            this.selectedRows.push(asset)
        } else {
            this.selectedRows = this.selectedRows.filter(row => row.id !== asset.id);
        }

        this.isAllRowsSelected = this.selectedRows.length === this.assets.length;

        this.toggleMultiRowSelectedOptions()

    }

    resetSelectedRows():void {
        this.selectedRows = [];
        this.isAllRowsSelected = false;
        this.multiItemSelectPanel?.close();
    }

    isSelectedRow(asset: Asset):boolean {
        return this.selectedRows.some(item => item.id === asset.id)
    }

    isFolderRowSelected():boolean {
        const index = this.selectedRows.findIndex(row => row.type == 'FOLDER')
        return index !== -1

    }

    toggleMultiRowSelectedOptions():void {
        if (this.selectedRows.length > 0) {
            this.multiItemSelectPanel.open();
        } else {
            this.multiItemSelectPanel.close();
        }
    }

    onRowClick(file:Asset){
        const isSelected = this.isSelectedRow(file);
        this.toggleRowCheck(!isSelected, file);
    }

    onFileDblClick(file: Asset): void {
        // No details drawer here
        if (this._actionRegistry.isAllowed('view', file)) {
            this.previewFile(file);
        } else if (this._actionRegistry.isAllowed('openOnDesktop', file)) {
            this._desktopAgentService.launch(file);
        }
    }

    clearSearch(){
        this.eventSer.onSearchClear.emit()
    }

}
